import Vue from "vue";
import VueRouter from "vue-router";
import Main from "@/pages/Main.vue";
import Dashboard from "@/pages/Dashboard.vue";
import Dashboard2 from "@/pages/Dashboard2.vue";
import News from "@/pages/News.vue";
import User from "@/pages/User.vue";
import Announcement from "@/pages/Announcement.vue";
import Donation from "@/pages/Donation.vue";
import DonationInventoryRegistration from "@/components/DonationInventoryRegistration.vue";
import SymptomPrevent from "@/pages/SymptomPrevent.vue";
import FAQs from "@/pages/FAQs.vue";
import ContactTracing from "@/pages/ContactTracing.vue";
import PositiveActions from "@/pages/PositiveActions.vue";
import Reports from "@/pages/Reports.vue";

import Login from "../pages/Login.vue";
import ChangePassword from "../pages/ChangePassword.vue"
import Pandemic_List from "../pages/Pandemic_List.vue";
import firebase from 'firebase';

Vue.use(VueRouter);

const routes = [{
        path: "/",
        name: "login",
        component: Login,
    },
    {
        path: '/change-password',
        name: 'changePassword',
        component: ChangePassword,
        meta: {
            authRequired: true,
        },
    },
    {
        path: "/pandemic_List",
        name: "pandemic_List",
        component: Pandemic_List,
        beforeEnter: (to, from, next) => {
            firebase.auth().onAuthStateChanged((user) =>{
                if(user){
                    next()
                }
                else{
                    next('/')

                }
            })
        }
    },
    {
        path: "/main",
        name: "main",
        component: Main,
        children: [
            {
                path: "/dashboard",
                name: "dashboard",
                component: Dashboard,
                beforeEnter: (to, from, next) => {
                    firebase.auth().onAuthStateChanged((user) =>{
                        if(user){
                            next()
                        }
                        else{
                            next('/')
        
                        }
                    })
                }
            },
            {
                path: "/dashboard2",
                name: "dashboard2",
                component: Dashboard2,
                beforeEnter: (to, from, next) => {
                    firebase.auth().onAuthStateChanged((user) =>{
                        if(user){
                            next()
                        }
                        else{
                            next('/')
        
                        }
                    })
                }
            },
            {
                path: "/news",
                name: "news",
                component: News,
                beforeEnter: (to, from, next) => {
                    firebase.auth().onAuthStateChanged((user) =>{
                        if(user){
                            next()
                        }
                        else{
                            next('/')
        
                        }
                    })
                }
            },
            {
                path: "/users",
                name: "users",
                component: User,
                beforeEnter: (to, from, next) => {
                    firebase.auth().onAuthStateChanged((user) =>{
                        if(user){
                            next()
                        }
                        else{
                            next('/')
        
                        }
                    })
                }
            },
            {
                path: "/announcement",
                name: "announcement",
                component: Announcement,
                beforeEnter: (to, from, next) => {
                    firebase.auth().onAuthStateChanged((user) =>{
                        if(user){
                            next()
                        }
                        else{
                            next('/')
        
                        }
                    })
                }
            },
            {
                path: "/donation",
                name: "donation",
                component: Donation,
                beforeEnter: (to, from, next) => {
                    firebase.auth().onAuthStateChanged((user) =>{
                        if(user){
                            next()
                        }
                        else{
                            next('/')
        
                        }
                    })
                }
            },
            {
                path: "/donation/:id",
                name: "DonationInventoryRegistration",
                component: DonationInventoryRegistration,
                beforeEnter: (to, from, next) => {
                    firebase.auth().onAuthStateChanged((user) =>{
                        if(user){
                            next()
                        }
                        else{
                            next('/')
        
                        }
                    })
                }
 
            },
            {
                path: "/faqs",
                name: "faqs",
                component: FAQs,
                beforeEnter: (to, from, next) => {
                    firebase.auth().onAuthStateChanged((user) =>{
                        if(user){
                            next()
                        }
                        else{
                            next('/')
        
                        }
                    })
                }

            },
            {
                path: "/ContactTracing",
                name: "ContactTracing",
                component: ContactTracing,
                beforeEnter: (to, from, next) => {
                    firebase.auth().onAuthStateChanged((user) =>{
                        if(user){
                            next()
                        }
                        else{
                            next('/')
        
                        }
                    })
                }

            },
            {
                path: "/PositiveActions",
                name: "PositiveActions",
                component: PositiveActions,
                beforeEnter: (to, from, next) => {
                    firebase.auth().onAuthStateChanged((user) =>{
                        if(user){
                            next()
                        }
                        else{
                            next('/')
        
                        }
                    })
                }

            },
            {
                path: "/Reports",
                name: "Reports",
                component: Reports,
                beforeEnter: (to, from, next) => {
                    firebase.auth().onAuthStateChanged((user) =>{
                        if(user){
                            next()
                        }
                        else{
                            next('/')
        
                        }
                    })
                }
     
            },
            {
                path: "/symptom-and-prevent",
                name: "symptom-prevent",
                component: SymptomPrevent,
                beforeEnter: (to, from, next) => {
                    firebase.auth().onAuthStateChanged((user) =>{
                        if(user){
                            next()
                        }
                        else{
                            next('/')
        
                        }
                    })
                }

            },
        ]
    },

];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

///prevent router before login
// router.beforeEach((to, from, next) => {
//     if (to.matched.some(record => record.meta.authRequired)) {
//         if (firebase.auth().currentUser) {
//             next();
//         } else {
//             alert('You must be logged in to see this page');
//             next({
//                 path: '/',
//             });
//         }
//     } else {
//         next();
//     }
// });

export default router;